import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import DropdownFilter from "./DropdownFilter";
import FilterBubble from "./FilterBubble";
import CustomDropdown from "./CustomDropdown";
import {
    faFilterList
} from "@fortawesome/pro-regular-svg-icons";

const FilterDimension = ({ dimension = [], setdimension = () => { }, index, allowDeleteDimension = true, deleteDimension = () => {} }) => {
    const { t } = useTranslation();
    const [activeLabel, setActiveLabel] = useState(null);

    const handleSetFilter = (selected) => {
        const filterdimension = [...dimension];
        const filterCategory = filterdimension.find((filter) => filter.label === selected.label);
        filterCategory.selected = selected.selected;

        setdimension(filterdimension);
    }

    const setActiveByLabel = (label) => {
        setActiveLabel(label);
    };

    const setInActive = () => {
        setActiveLabel(null);
    };

    const clearFilter = () => {
        const updatedDimension = dimension.map((dimension) => ({
            ...dimension,
            selected: [],
        }));
        setdimension(updatedDimension);
    };

    const removeSelectedValue = (label, valueToRemove) => {
        // Find the object with the given label
        const filterdimension = [...dimension];
        const filterCategory = filterdimension.find((filter) => filter.label === label);

        // If the object is found, remove the value from the selected array
        if (filterCategory) {
            const index = filterCategory.selected.indexOf(valueToRemove);
            if (index !== -1) {
                filterCategory.selected.splice(index, 1);
            }
        }
        setdimension(filterdimension);
    }



    const getDimensionStyle = () => {
        if (index === 0) {
            return 'btn-outline-primary';
        } else if (index === 1) {
            return 'btn-outline-secondary';
        } else if (index === 2) {
            return 'btn-outline-warning';
        } else if (index === 3) {
            return 'btn-outline-error';
        } else {
            return 'btn-outline-mute';
        }
    }

    const countTotalSelectedElements = () => {
        // Flatten dimensions array and reduce to count the total length of 'selected' arrays
        return dimension.flat().reduce((total, dimension) => {
            return total + (dimension.selected ? dimension.selected.length : 0);
        }, 0);
    };

    return (
        <div className="flex gap-4 w-full flex-wrap">
            <CustomDropdown isRight={false} onClose={() => { setInActive() }} ContentComponent={() => {
                return <DropdownFilter dimension={dimension}
                    onChange={(e) => { handleSetFilter(e) }}
                    setIsActive={(e) => { setActiveByLabel(e) }} 
                    activeLabel={activeLabel}
                    allowDeleteDimension={allowDeleteDimension}
                    deleteDimension={() => {deleteDimension()}}
                    clearFilter={() => {clearFilter()}}/>
            }}>
                <FilterBubble icon={faFilterList} name={t("filter.Filter")} num={countTotalSelectedElements()} className={getDimensionStyle()} />
            </CustomDropdown>

            {dimension && dimension.map((filter, dimensionIndex) => {
                return filter.selected.map((filterLable, filterIndex) => {
                    return (
                        <FilterBubble key={`filter-${filter.label}-${filterLable}-${dimensionIndex}-selected-${filterIndex}-${index}`} name={t(`payment.${filterLable}`, { defaultValue: t(`status.${String(filterLable).toUpperCase()}`, { defaultValue: String(filterLable) }) })} className={getDimensionStyle()} toggle={() => { removeSelectedValue(filter.label, filterLable) }} />
                    )
                })

            })}
        </div>

    );
};

export default FilterDimension;
